import { Navigate, useLocation } from "react-router-dom";
import { useAuthStore } from "../state/authStore";
import { useTeamStore } from "../state/teamStore";
import { gateView } from "../utils/gateView";

function FullPageSpinner() {
  return (
    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100vh" }}>
      <div className="spinner" style={{ width: 32, height: 32 }} />
    </div>
  );
}


export default function TeamOnboardingGate({ children }: { children: React.ReactNode }) {
  const location = useLocation();
  const { user } = useAuthStore();
  // App fetches teams when the signed-in user changes.
  const { teams, initialized } = useTeamStore();

  const view = gateView({ signedIn: !!user, pathname: location.pathname, initialized, teamCount: teams.length });
  if (view === "spinner") return <FullPageSpinner />;
  if (view === "me") return <Navigate to="/me" replace />;
  return <>{children}</>;
}
